import actionTypes from '../constants/action-types';

const height = (state = 0, action) => {
  if (action.type !== actionTypes.SET_HEIGHT) return state;
  return action.payload.value;
};

export default height;
